var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	318: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))))),
	7780: () => (loadSingletonVersion("default", "i18next", false, [1,23,15,2], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2635))))))),
	9491: () => (loadSingletonVersion("default", "react-i18next", false, [1,15,0,2], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2389))))))),
	676: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(961))))))),
	5838: () => (loadSingletonVersion("default", "@flex-reality/i18n-sdk-react", false, [0], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318), __webpack_require__.e(660)]).then(() => (() => (__webpack_require__(7761))))))),
	8316: () => (loadSingletonVersion("default", "graphql", false, [1,16,8,1], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3942))))))),
	1225: () => (loadSingletonVersion("default", "mixpanel-browser", false, [1,2,78,0], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6751))))))),
	1394: () => (loadSingletonVersion("default", "@apollo/client", false, [1,3,8,8], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2504))))))),
	6229: () => (loadSingletonVersion("default", "@flexreality/ui-toolkit", false, [4,0,2,0], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(142), __webpack_require__.e(543)]).then(() => (() => (__webpack_require__(665))))))),
	4142: () => (loadSingletonVersion("default", "styled-components", false, [1,6,1,13], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(3679))))))),
	214: () => (loadSingletonVersion("default", "@mui/material/Box", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(66)]).then(() => (() => (__webpack_require__(7382))))))),
	560: () => (loadSingletonVersion("default", "@mui/material/DialogContentText", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590)]).then(() => (() => (__webpack_require__(5829))))))),
	626: () => (loadSingletonVersion("default", "@mui/material/utils", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590)]).then(() => (() => (__webpack_require__(8928))))))),
	1984: () => (loadSingletonVersion("default", "@mui/material/Button", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590), __webpack_require__.e(66)]).then(() => (() => (__webpack_require__(8729))))))),
	4162: () => (loadSingletonVersion("default", "@mui/material/DialogActions", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590)]).then(() => (() => (__webpack_require__(3992))))))),
	4782: () => (loadSingletonVersion("default", "@mui/material/DialogContent", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590)]).then(() => (() => (__webpack_require__(2514))))))),
	5408: () => (loadSingletonVersion("default", "@mui/material/DialogTitle", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590)]).then(() => (() => (__webpack_require__(4309))))))),
	9454: () => (loadSingletonVersion("default", "@mui/material", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(329), __webpack_require__.e(590), __webpack_require__.e(66), __webpack_require__.e(676), __webpack_require__.e(778)]).then(() => (() => (__webpack_require__(9958))))))),
	756: () => (loadSingletonVersion("default", "@mui/system/styleFunctionSx", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3857))))))),
	8497: () => (loadSingletonVersion("default", "@mui/system/colorManipulator", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(771))))))),
	9966: () => (loadSingletonVersion("default", "@mui/system/createTheme", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3142))))))),
	3066: () => (loadSingletonVersion("default", "@mui/system", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(7366))))))),
	8060: () => (loadSingletonVersion("default", "@mui/system/DefaultPropsProvider", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5153))))))),
	8149: () => (loadSingletonVersion("default", "@mui/system/createStyled", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(6461))))))),
	918: () => (loadSingletonVersion("default", "@mui/system/Unstable_Grid", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(5778))))))),
	1090: () => (loadSingletonVersion("default", "@mui/system/useMediaQuery", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(3564))))))),
	7002: () => (loadSingletonVersion("default", "@mui/system/InitColorSchemeScript", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(898))))))),
	8493: () => (loadSingletonVersion("default", "@mui/system/useThemeWithoutDefault", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(2923))))))),
	8692: () => (loadSingletonVersion("default", "@mui/system/useThemeProps", false, [1,5,16,7], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(4445))))))),
	9050: () => (loadSingletonVersion("default", "@mui/system/RtlProvider", false, [1,5,16,7], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3788))))))),
	5795: () => (loadSingletonVersion("default", "@mui/styled-engine", false, [1,6,1,2], () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(142)]).then(() => (() => (__webpack_require__(6785))))))),
	1834: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,3,4], () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3924)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"60": [
		1834
	],
	"66": [
		3066
	],
	"83": [
		1225,
		1394,
		6229
	],
	"142": [
		4142
	],
	"316": [
		8316
	],
	"318": [
		318
	],
	"329": [
		756,
		8497,
		9966
	],
	"543": [
		214,
		560,
		626,
		1984,
		4162,
		4782,
		5408,
		9454
	],
	"590": [
		8060,
		8149
	],
	"660": [
		7780,
		9491
	],
	"676": [
		676
	],
	"778": [
		918,
		1090,
		7002,
		8493,
		8692,
		9050
	],
	"795": [
		5795
	],
	"838": [
		5838
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}